import { Apple, Play } from "lucide-react";

// App Store / Google Play placeholder buttons.
// Deliberately NOT links — visually ready but marked "Coming Soon".
function StoreButton({ store, testid }) {
  const isApple = store === "apple";
  return (
    <div
      role="button"
      aria-disabled="true"
      title="Coming Soon"
      data-testid={testid}
      className="group relative inline-flex items-center gap-3 rounded-xl border border-charcoal/15 bg-charcoal px-5 py-3 text-cream opacity-60 cursor-not-allowed select-none"
    >
      {isApple ? <Apple className="h-6 w-6" /> : <Play className="h-6 w-6" />}
      <span className="text-left leading-tight">
        <span className="block text-[10px] uppercase tracking-[0.18em] text-cream/70">
          {isApple ? "Download on the" : "Get it on"}
        </span>
        <span className="block text-sm font-semibold">
          {isApple ? "App Store" : "Google Play"}
        </span>
      </span>
      <span className="ml-1 rounded-full bg-sunny px-2 py-0.5 text-[9px] font-bold uppercase tracking-wider text-charcoal">
        Coming Soon
      </span>
    </div>
  );
}

export default function StoreButtons({ appSlug = "app", showWebApp = false }) {
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid={`store-buttons-${appSlug}`}>
      <StoreButton store="apple" testid={`apple-store-${appSlug}`} />
      <StoreButton store="google" testid={`google-play-${appSlug}`} />
      {showWebApp && (
        <div
          aria-disabled="true"
          title="Coming Soon"
          data-testid={`web-app-${appSlug}`}
          className="inline-flex items-center gap-2 rounded-xl border-2 border-dashed border-purple/40 px-5 py-3 text-sm font-semibold text-purple/70 cursor-not-allowed select-none"
        >
          Web app — link coming soon
        </div>
      )}
    </div>
  );
}
